<mat-dialog-content class="attachment-container">
	<div class="field-container">
		<span class="ellipsis"
			  matTooltip="{{'CATEGORY' | translate}}"> {{ 'CATEGORY' | translate }}
		</span>
		<custom-ext-select
			[(defaultValue)]="selectedCategory"
			[disabled]="isLoading"
			[values]="categoryOptions"
			[searchable]="true"
			[extraClass]="'filter-multi-select filter-full-width'">
		</custom-ext-select>
	</div>
	<app-dnd [extraData] = "selectedCategory">

	</app-dnd>
</mat-dialog-content>
